import { render, staticRenderFns } from "./CourseEnrollmentGradebook.vue?vue&type=template&id=a3535456&scoped=true&"
import script from "./CourseEnrollmentGradebook.vue?vue&type=script&lang=js&"
export * from "./CourseEnrollmentGradebook.vue?vue&type=script&lang=js&"
import style0 from "./CourseEnrollmentGradebook.vue?vue&type=style&index=0&id=a3535456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3535456",
  null
  
)

export default component.exports